import { PreviewComponentProps } from "@camberi/firecms";
import { ReactElement } from "react";

export default function CustomYearPreview({ value, property, size }: PreviewComponentProps<any>): ReactElement {
  const dt = new Date(value)

  return <span>{dt.getFullYear()}</span>
}
